import { Component, OnInit } from '@angular/core'
import { SidebarService } from '../services/sidebar.service'

@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss'],
    standalone: false
})
export class ContentComponent implements OnInit {
  constructor(public sidebarService: SidebarService) {}

  ngOnInit(): void {
    this.sidebarService.hideSidebar = false
  }
}
